import { render, staticRenderFns } from "./add-category.vue?vue&type=template&id=edb55f06&"
import script from "./add-category.vue?vue&type=script&lang=js&"
export * from "./add-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports